import { EnvironmentContext } from '@/contexts/EnvironmentContext.js';
import { useContext } from 'react';

export const useIsPlaywright = () => {
  const environment = useContext(EnvironmentContext);

  return Boolean(environment?.isPlaywrightTestEnvironment);
};
